import Table from "react-bootstrap/Table";

export const TransactionTable = () => {
  return (
    <Table striped>
      <thead>
        <tr>
          <th>Period</th>
          <th>Recorder</th>
          <th>ამორტიზაცია</th>
          <th>ღირებულება</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{new Date().toLocaleString()}</td>
          <td>Lorem ipsum</td>
          <td>11:53</td>
          <td>1160</td>
        </tr>
        <tr>
          <td>{new Date().toLocaleString()}</td>
          <td>Lorem ipsum</td>
          <td>11:53</td>
          <td>1160</td>
        </tr>
        <tr>
          <td>{new Date().toLocaleString()}</td>
          <td>Lorem ipsum</td>
          <td>11:53</td>
          <td>1160</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default TransactionTable;
